import apiWorker from '../apiWorker'

const billing = {
    getContact : (contact_id) => apiWorker('get', `/v1/billing/contact/${contact_id}`),
    getPayForm : (contact_id) => apiWorker('get', `/v1/billing/payform/${contact_id}?stylesheet=${window.location.origin}/payment.css`),
}

export default billing;